"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.policyDeleteDataWorker = policyDeleteDataWorker;
exports.policyViewToggleWatcher = policyViewToggleWatcher;
exports.policyViewToggleWorker = policyViewToggleWorker;
exports.default = void 0;

var _effects = require("redux-saga/effects");

var _action = require("../../notification/action");

var _constants = require("./constants");

var _externalization = require("../../../packages/policy-management/externalization");

var _actions = require("./actions");

var _commonConstants = require("../../../utils/common-constants");

var _policyAdminService = require("../../../services/policy-admin-service");

var _lodash = require("lodash");

var _service = require("../../policy/Members/service");

var _actions2 = require("../../policy/Members/actions");

var _commonUtils = require("../../../utils/common-utils");

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(policyViewDataWatcher),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(policyViewDataWorker),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(policyViewDataJSONWatcher),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(policyViewDataJSONWorker),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(policyDeleteDataWatcher),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(policyDeleteDataWorker),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(policyViewToggleWatcher),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(policyViewToggleWorker),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(fetchNotificationMediumDetailsWatcher),
    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(fetchNotificationMediumDetailsWorker);

function policyViewDataWatcher() {
  return regeneratorRuntime.wrap(function policyViewDataWatcher$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.takeLatest)(_constants.PolicyViewDataTypes.POLICY_VIEW_DATA_REQUEST, policyViewDataWorker);

        case 2:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

function policyViewDataWorker(_ref) {
  var payload, policyId, history, consumer, consumerEntityId, redirectPath, policyViewData, usersToFetch, tagsToFetch, tagsData, userData, _response$data, response, reason;

  return regeneratorRuntime.wrap(function policyViewDataWorker$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _ref.payload;
          policyId = payload.policyId, history = payload.history, consumer = payload.consumer, consumerEntityId = payload.consumerEntityId, redirectPath = payload.redirectPath;
          _context2.prev = 2;
          _context2.next = 5;
          return (0, _effects.put)((0, _actions.getPolicyByIdLoading)());

        case 5:
          _context2.next = 7;
          return (0, _effects.put)((0, _actions.approvalNotificationMediumDetailsReset)());

        case 7:
          _context2.next = 9;
          return (0, _effects.call)(_policyAdminService.getPolicyByEntity, policyId, null, consumer, consumerEntityId);

        case 9:
          policyViewData = _context2.sent;
          usersToFetch = (0, _commonUtils.getPolicyUsersMapById)(policyViewData);
          tagsToFetch = (0, _commonUtils.getPolicyUserTagsMapById)(policyViewData);

          if ((0, _lodash.isEmpty)(tagsToFetch)) {
            _context2.next = 18;
            break;
          }

          _context2.next = 15;
          return (0, _effects.put)((0, _actions2.getGroupsRequestLoading)());

        case 15:
          _context2.next = 17;
          return (0, _effects.call)(_service.getSelectedUserTagsData, tagsToFetch);

        case 17:
          tagsData = _context2.sent;

        case 18:
          if ((0, _lodash.isEmpty)(usersToFetch)) {
            _context2.next = 24;
            break;
          }

          _context2.next = 21;
          return (0, _effects.put)((0, _actions2.getUsersRequestLoading)());

        case 21:
          _context2.next = 23;
          return (0, _effects.call)(_service.getSelectedUsersData, usersToFetch);

        case 23:
          userData = _context2.sent;

        case 24:
          policyViewData.isConditionTypeJSON = _typeof(policyViewData === null || policyViewData === void 0 ? void 0 : policyViewData.condition) === 'object';

          if (!(0, _lodash.isEmpty)(policyViewData === null || policyViewData === void 0 ? void 0 : policyViewData.condition) && typeof (policyViewData === null || policyViewData === void 0 ? void 0 : policyViewData.condition) === 'string') {
            policyViewData['condition'] = JSON.parse(policyViewData.condition);
          }

          _context2.next = 28;
          return (0, _effects.put)((0, _actions.getPolicyByIdSuccess)(policyViewData));

        case 28:
          _context2.next = 30;
          return (0, _effects.put)((0, _actions2.getGroupsRequestSuccess)((0, _lodash.isEmpty)(tagsData) ? [] : tagsData));

        case 30:
          _context2.next = 32;
          return (0, _effects.put)((0, _actions2.getUsersRequestSuccess)((0, _lodash.isEmpty)(userData) ? [] : userData));

        case 32:
          _context2.next = 41;
          break;

        case 34:
          _context2.prev = 34;
          _context2.t0 = _context2["catch"](2);
          response = _context2.t0.response;
          reason = (response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.message) || '';
          _context2.next = 40;
          return (0, _effects.put)((0, _actions.getPolicyByIdFailure)(reason));

        case 40:
          history.push({
            pathname: redirectPath,
            notification: {
              title: _constants.translatedStrings.errorPolicyViewData(reason),
              type: _commonConstants.errorNotificationType,
              time: 'normal'
            }
          });

        case 41:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[2, 34]]);
}

function policyViewDataJSONWatcher() {
  return regeneratorRuntime.wrap(function policyViewDataJSONWatcher$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.takeLatest)(_constants.PolicyViewDataTypes.POLICY_VIEW_DATA_JSON_REQUEST, policyViewDataJSONWorker);

        case 2:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}

function policyViewDataJSONWorker(_ref3) {
  var payload, policyName, history, consumer, consumerEntityId, redirectPath, policyViewData, _response$data2, response, reason;

  return regeneratorRuntime.wrap(function policyViewDataJSONWorker$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          payload = _ref3.payload;
          policyName = payload.policyName, history = payload.history, consumer = payload.consumer, consumerEntityId = payload.consumerEntityId, redirectPath = payload.redirectPath;
          _context4.prev = 2;
          _context4.next = 5;
          return (0, _effects.put)((0, _actions.getPolicyByNameLoading)());

        case 5:
          _context4.next = 7;
          return (0, _effects.put)((0, _actions.approvalNotificationMediumDetailsReset)());

        case 7:
          _context4.next = 9;
          return (0, _effects.call)(_policyAdminService.getPolicyByEntity, policyName, null, consumer, consumerEntityId);

        case 9:
          policyViewData = _context4.sent;
          policyViewData.isConditionTypeJSON = _typeof(policyViewData === null || policyViewData === void 0 ? void 0 : policyViewData.condition) === 'object';

          if (!(0, _lodash.isEmpty)(policyViewData === null || policyViewData === void 0 ? void 0 : policyViewData.condition) && typeof (policyViewData === null || policyViewData === void 0 ? void 0 : policyViewData.condition) === 'string') {
            policyViewData['condition'] = JSON.parse(policyViewData.condition);
          }

          _context4.next = 14;
          return (0, _effects.put)((0, _actions.getPolicyByNameSuccess)(policyViewData));

        case 14:
          _context4.next = 23;
          break;

        case 16:
          _context4.prev = 16;
          _context4.t0 = _context4["catch"](2);
          response = _context4.t0.response;
          reason = (response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.message) || '';
          _context4.next = 22;
          return (0, _effects.put)((0, _actions.getPolicyByNameFailure)(reason));

        case 22:
          history.push({
            pathname: redirectPath,
            notification: {
              title: _constants.translatedStrings.errorPolicyViewData(reason),
              type: _commonConstants.errorNotificationType,
              time: 'normal'
            }
          });

        case 23:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, null, [[2, 16]]);
}

function policyDeleteDataWatcher() {
  return regeneratorRuntime.wrap(function policyDeleteDataWatcher$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.takeLatest)(_constants.PolicyDeleteDataTypes.POLICY_DELETE_DATA_REQUEST, policyDeleteDataWorker);

        case 2:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}

function policyDeleteDataWorker(_ref5) {
  var payload, policyId, history, consumer, consumerEntityId, redirectPath, deletePolicyStatus, _response$data3, response, reason;

  return regeneratorRuntime.wrap(function policyDeleteDataWorker$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          payload = _ref5.payload;
          policyId = payload.policyId, history = payload.history, consumer = payload.consumer, consumerEntityId = payload.consumerEntityId, redirectPath = payload.redirectPath;
          _context6.next = 4;
          return (0, _effects.put)({
            type: _constants.PolicyDeleteDataTypes.POLICY_DELETE_DATA_LOADING
          });

        case 4:
          _context6.prev = 4;
          _context6.next = 7;
          return (0, _effects.call)(_policyAdminService.deletePolicyId, {
            id: policyId,
            consumer: consumer,
            consumerEntityId: consumerEntityId
          });

        case 7:
          deletePolicyStatus = _context6.sent;
          _context6.next = 10;
          return (0, _effects.put)({
            type: _constants.PolicyDeleteDataTypes.POLICY_DELETE_DATA_SUCCESS,
            payload: deletePolicyStatus
          });

        case 10:
          history.push({
            pathname: redirectPath,
            notification: {
              title: (0, _externalization.translate)('POLICIES_MODULE.DELETE_POLICY_SUCCESS_MESSAGE'),
              type: _commonConstants.successNotificationType,
              time: 'normal'
            }
          });
          _context6.next = 20;
          break;

        case 13:
          _context6.prev = 13;
          _context6.t0 = _context6["catch"](4);
          response = _context6.t0.response;
          reason = (response === null || response === void 0 ? void 0 : (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.message) || '';
          _context6.next = 19;
          return (0, _effects.put)({
            type: _constants.PolicyDeleteDataTypes.POLICY_DELETE_DATA_FAILURE,
            payload: {
              error: reason
            }
          });

        case 19:
          history.push({
            pathname: redirectPath,
            notification: {
              title: (0, _externalization.translate)('POLICIES_MODULE.DELETE_POLICY_ERROR_MESSAGE_WITH_REASON', {
                reason: reason
              }),
              type: _commonConstants.errorNotificationType,
              time: 'normal'
            }
          });

        case 20:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6, null, [[4, 13]]);
}

function policyViewToggleWatcher() {
  return regeneratorRuntime.wrap(function policyViewToggleWatcher$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.takeLatest)(_constants.PolicyViewDataTypes.POLICY_VIEW_TOGGLE_REQUEST_INIT, policyViewToggleWorker);

        case 2:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7);
}

function policyViewToggleWorker(_ref7) {
  var payload, id, status, consumer, consumerEntityId, togglePolicyStatus, _response$data4, response, reason;

  return regeneratorRuntime.wrap(function policyViewToggleWorker$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          payload = _ref7.payload;
          id = payload.id, status = payload.status, consumer = payload.consumer, consumerEntityId = payload.consumerEntityId;
          _context8.next = 4;
          return (0, _effects.put)({
            type: _constants.PolicyViewDataTypes.POLICY_VIEW_TOGGLE_REQUEST_LOADING
          });

        case 4:
          _context8.prev = 4;
          _context8.next = 7;
          return (0, _effects.call)(_policyAdminService.editPolicyByEntity, {
            isActive: !(status === _constants.enabledPolicy)
          }, id, consumer, consumerEntityId);

        case 7:
          togglePolicyStatus = _context8.sent;
          _context8.next = 10;
          return (0, _effects.put)({
            type: _constants.PolicyViewDataTypes.POLICY_VIEW_TOGGLE_REQUEST_COMPLETE,
            payload: togglePolicyStatus
          });

        case 10:
          _context8.next = 12;
          return (0, _effects.put)((0, _action.openNotification)(_commonConstants.successNotificationType, (0, _constants.getTogglePolicySuccessMessage)(status), true, _commonConstants.successNotificationDuration));

        case 12:
          _context8.next = 14;
          return (0, _effects.put)({
            type: _constants.PolicyViewDataTypes.POLICY_VIEW_DATA_REQUEST,
            payload: {
              policyId: id,
              history: history
            }
          });

        case 14:
          _context8.next = 24;
          break;

        case 16:
          _context8.prev = 16;
          _context8.t0 = _context8["catch"](4);
          response = _context8.t0.response;
          reason = (response === null || response === void 0 ? void 0 : (_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : _response$data4.message) || '';
          _context8.next = 22;
          return (0, _effects.put)({
            type: _constants.PolicyViewDataTypes.POLICY_VIEW_TOGGLE_REQUEST_FAILURE,
            payload: reason
          });

        case 22:
          _context8.next = 24;
          return (0, _effects.put)((0, _action.openNotification)(_commonConstants.errorNotificationType, (0, _constants.getTogglePolicyErrorMessage)(payload.status, reason), true, _commonConstants.errorNotificationDuration));

        case 24:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8, null, [[4, 16]]);
}

function fetchNotificationMediumDetailsWatcher() {
  return regeneratorRuntime.wrap(function fetchNotificationMediumDetailsWatcher$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.takeLatest)(_constants.approvalNotificationMediumDetailsType.APPROVAL_NOTIFICATION_MEDIUM_DETAILS_REQUEST, fetchNotificationMediumDetailsWorker);

        case 2:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked9);
}

function fetchNotificationMediumDetailsWorker(_ref9) {
  var payload, channelId, notificationMediumData, filteredObj;
  return regeneratorRuntime.wrap(function fetchNotificationMediumDetailsWorker$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          payload = _ref9.payload;
          channelId = payload.channelId;
          _context10.next = 4;
          return (0, _effects.select)(function (state) {
            var _state$policyReducer, _state$policyReducer$, _state$policyReducer$2;

            return state === null || state === void 0 ? void 0 : (_state$policyReducer = state.policyReducer) === null || _state$policyReducer === void 0 ? void 0 : (_state$policyReducer$ = _state$policyReducer.add) === null || _state$policyReducer$ === void 0 ? void 0 : (_state$policyReducer$2 = _state$policyReducer$.notificationMedium) === null || _state$policyReducer$2 === void 0 ? void 0 : _state$policyReducer$2.data;
          });

        case 4:
          notificationMediumData = _context10.sent;
          filteredObj = notificationMediumData === null || notificationMediumData === void 0 ? void 0 : notificationMediumData.find(function (ele) {
            return ele.id === channelId;
          });

          if (!filteredObj) {
            _context10.next = 9;
            break;
          }

          _context10.next = 9;
          return (0, _effects.put)((0, _actions.approvalNotificationMediumDetailsSuccess)(filteredObj));

        case 9:
        case "end":
          return _context10.stop();
      }
    }
  }, _marked10);
}

var _default = (0, _effects.all)([(0, _effects.fork)(policyViewDataWatcher), (0, _effects.fork)(policyDeleteDataWatcher), (0, _effects.fork)(policyViewToggleWatcher), (0, _effects.fork)(fetchNotificationMediumDetailsWatcher), (0, _effects.fork)(policyViewDataJSONWatcher)]);

exports.default = _default;